<script setup>
import { getCompanyBase, getCompanyTime, getCompanyCert } from '/api/company.js'

import axios from 'axios'

import { useI18n } from 'vue-i18n'

import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据


const HeziyunData = ref(parseHeziyunData().global)

console.log(HeziyunData.value)


const { t } = useI18n()

import HzQuickjump from '@/components/main/HzQuickjump.vue'


// 快捷跳转
const quickJump = ref([
    { id: 1, name: t('company.quickJump.companyProfile'), target: 'Heziyun-concise' },
    { id: 2, name: t('company.quickJump.corporateCulture'), target: 'Heziyun-corporateCulture' },
    { id: 3, name: t('company.quickJump.qualifications'), target: 'Heziyun-qualifications' },
    { id: 4, name: t('company.quickJump.honorRoad'), target: 'Heziyun-pathwayToGlory' },
    { id: 5, name: t('company.quickJump.feedback'), target: 'Heziyun-consultationFeedback' },
])

// 智简登陆后缓存本地的token
const jwt = ref(localStorage.getItem('jwt') || null)

// 咨询反馈数据
const feedbackData = reactive({
    title: '',
    contact: '',
    description: ''
})

// 错误状态
const errors = reactive({
    title: false,
    contact: false,
    description: false
})

// 提交状态
const submitting = ref(false)

// 意见类型
const feedback_types = ref([])
const typeSelection = ref('')

// 公司基本信息
const companyBases = ref({})
const companyTime = ref({})
const companyCert = ref({})

// 计算属性：获取激活样式
const getActiveStyle = computed(() => (id) => ({
    backgroundColor: id === typeSelection.value ? 'rgb(26, 92, 255)' : '',
    color: id === typeSelection.value ? '#fff' : '',
}))

// 获取完整的图片URL
const getFullImageUrl = (path) => {
    if (!path) return ''
    if (/^https?:\/\//.test(path)) {
        return path
    }
    return window.location.origin + path
}

// 提取警号中的数字
const policeNumber = (police) => {
    const match = police?.match(/\d+/)
    return match ? match[0] : ""
}

// 并发请求所有公司信息
const getCompanyData = async () => {
    try {
        const [baseRes, timeRes, certRes] = await Promise.all([
            getCompanyBase(),
            getCompanyTime(),
            getCompanyCert()
        ])

        companyBases.value = baseRes.data
        companyTime.value = timeRes.data.list
        companyCert.value = certRes.data.list
    } catch (error) {
        console.error('请求失败:', error)
    }
}

// 获取反馈类型
const feedbackType = async () => {
    try {
        const res = await axios.get('/console/v1/common')
        feedback_types.value = res.data.data.feedback_type
        typeSelection.value = res.data.data.feedback_type[0]?.id || ''
    } catch (error) {
        console.error('获取反馈类型失败:', error)
    }
}

// 验证联系人
const validateContact = () => {
    if (feedbackData.title) {
        errors.title = false
    }
}

// 验证内容
const validateContent = () => {
    if (feedbackData.description) {
        errors.description = false
    }
}

// 验证联系人信息（手机和邮箱）
const validateContactInfo = () => {
    const phoneValid = feedbackData.contact && /^1[3-9]\d{9}$/.test(feedbackData.contact)
    const emailValid = feedbackData.contact && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(feedbackData.contact)

    if (phoneValid || emailValid) {
        errors.contact = false
    } else {
        errors.contact = !!feedbackData.contact
    }
}

// 表单验证
const validateForm = () => {
    let isValid = true
    resetErrors()

    if (!feedbackData.title) {
        errors.title = true
        isValid = false
    }

    const phoneValid = feedbackData.contact && /^1[3-9]\d{9}$/.test(feedbackData.contact)
    const emailValid = feedbackData.contact && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(feedbackData.contact)

    if (!phoneValid && !emailValid) {
        errors.contact = true
        isValid = false
    }

    if (!feedbackData.description) {
        errors.description = true
        isValid = false
    }

    return isValid
}

// 重置表单
const resetForm = () => {
    feedbackData.title = ''
    feedbackData.contact = ''
    feedbackData.description = ''
    resetErrors()
}

// 重置错误状态
const resetErrors = () => {
    errors.title = false
    errors.contact = false
    errors.description = false
}

// 提交咨询反馈
const handleSubmit = async () => {
    if (submitting.value) return
    submitting.value = true

    try {
        if (!validateForm()) {
            submitting.value = false
            return
        }

        const formData = {
            type: typeSelection.value,
            title: feedbackData.title,
            contact: feedbackData.contact,
            description: feedbackData.description
        }

        const response = await axios.post('/console/v1/feedback', formData, {
            headers: {
                Authorization: `Bearer ${jwt.value}`
            }
        })


        if (response.data.status == 200) {
            resetForm()
        }
    } catch (error) {
        console.error('提交出错:', error)
    } finally {
        submitting.value = false
    }
}

// 生命周期钩子
onMounted(() => {
    feedbackType()
    getCompanyData()
})
</script>
<template>

    <!-- banner图 -->
    <div class="Heziyun-banners">
        <img :src="getFullImageUrl(companyBases.img)" alt="" class="Heziyun-bannerImg">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">
                    {{ HeziyunData?.webname }} · {{ $t('company.aboutUs') }}
                </span>
                <p v-intersect="{ class: 'bottom-top', delay: 200 }">{{ $t('company.bannerSlogan') }}
                </p>
            </div>
        </div>
    </div>

    <!-- nav 快捷跳转 -->
    <HzQuickjump :quickjump="quickJump"></HzQuickjump>

    <!-- 公司简介 -->
    <div class="Heziyun-concise Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-content">
                <div class="Heziyun-left" v-intersect="{ class: 'left-right', delay: 0 }">
                    <span class="Heziyun-title"><i>{{ $t('company.companyProfile.title') }}</i> {{
                        $t('company.companyProfile.title2') }}</span>
                    <p>
                        {{ companyBases.tips }}
                    </p>
                    <div class="Heziyun-option">
                        <div class="Heziyun-item">
                            <span><i>{{ companyBases.param_tit1 }}</i></span>
                            <p>{{ companyBases.param_tips1 }}</p>
                            <img src="@/static/img/company/dizuo.png" alt="">
                        </div>
                        <div class="Heziyun-item">
                            <span><i>{{ companyBases.param_tit2 }}</i></span>
                            <p>{{ companyBases.param_tips2 }}</p>
                            <img src="@/static/img/company/dizuo.png" alt="">
                        </div>
                        <div class="Heziyun-item">
                            <span><i>{{ companyBases.param_tit3 }}</i></span>
                            <p>{{ companyBases.param_tips3 }}</p>
                            <img src="@/static/img/company/dizuo.png" alt="">
                        </div>
                        <div class="Heziyun-item">
                            <span><i>{{ companyBases.param_tit4 }}</i></span>
                            <p>{{ companyBases.param_tips4 }}</p>
                            <img src="@/static/img/company/dizuo.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 企业文化 -->
    <div class="Heziyun-corporateCulture Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{
                    $t('company.corporateCulture.title') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{
                    $t('company.corporateCulture.subtitle') }}</p>
            </div>
            <div class="Heziyun-content">
                <div class="Heziyun-item" v-intersect="{ class: 'left-right', delay: 100 }">
                    <img src="@/static/img/company/culture_1.png" alt="">
                    <div class="Heziyun-text">
                        <span>{{ $t('company.corporateCulture.mission.title') }}</span>
                        <p>{{ $t('company.corporateCulture.mission.desc') }}</p>
                    </div>
                </div>
                <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 100 }">
                    <img src="@/static/img/company/culture_2.png" alt="">
                    <div class="Heziyun-text">
                        <span>{{ $t('company.corporateCulture.vision.title') }}</span>
                        <p>{{ $t('company.corporateCulture.vision.desc') }}</p>
                    </div>
                </div>
                <div class="Heziyun-item" v-intersect="{ class: 'right-left', delay: 100 }">
                    <img src="@/static/img/company/culture_3.png" alt="">
                    <div class="Heziyun-text">
                        <span>{{ $t('company.corporateCulture.values.title') }}</span>
                        <p>{{ $t('company.corporateCulture.values.desc') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 资质认证 -->
    <div class="Heziyun-qualifications Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{
                    $t('company.qualifications.title') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }"></p>
            </div>
            <div class="Heziyun-content">
                <div class="Heziyun-dashedLine"><img src="@/static/img/company/auth_line.png" alt="">
                </div>
                <div class="Heziyun-location">
                    <div class="Heziyun-item" v-for="(item, index) in companyCert"
                        v-intersect="{ class: 'bottom-top', delay: index * 50 }">
                        <img :src="getFullImageUrl(item.img)" alt="">
                        <div class="Heziyun-flexmin">
                            <div class="Heziyun-time">{{ item.title }}</div>
                            <p>{{ item.tips }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 荣誉之路 -->
    <div class="Heziyun-pathwayToGlory Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('company.honorRoad.title')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('company.honorRoad.subtitle')
                }}</p>
            </div>
            <div class="Heziyun-content">
                <div class="Heziyun-item" v-for="(item, index) in companyTime"
                    v-intersect="{ class: 'left-right', delay: index * 50 }">
                    <div class="Heziyun-year">{{ item.date }}</div>
                    <div class="Heziyun-dividingLine">
                        <div class="Heziyun-circular"></div>
                        <div class="Heziyun-line"></div>
                    </div>
                    <div class="Heziyun-son">
                        <div class="Heziyun-itemSon">
                            <span>{{ item.title }}</span>
                            <p>{{ item.tips }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 咨询反馈 -->
    <div class="Heziyun-consultationFeedback Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-content">
                <div class="Heziyun-left" v-intersect="{ class: 'left-right', delay: 50 }">
                    <div class="Heziyun-title">{{ $t('company.feedback.title') }}</div>
                    <input type="text" :placeholder="$t('company.feedback.titlePlaceholder')"
                        v-model="feedbackData.title" :class="{ 'error': errors.title }" @input="validateContact">
                    <input type="text" :placeholder="$t('company.feedback.contactPlaceholder')"
                        v-model="feedbackData.contact" :class="{ 'error': errors.contact }"
                        @input="validateContactInfo">
                    <div class="Heziyun-title">{{ $t('company.feedback.descriptionLabel') }}</div>
                    <textarea :placeholder="$t('company.feedback.descriptionPlaceholder')"
                        v-model="feedbackData.description" :class="{ 'error': errors.description }"
                        @input="validateContent"></textarea>
                    <div class="Heziyun-submit" @click="handleSubmit()">
                        <a-button>{{ $t('company.feedback.submitButton') }}</a-button>
                    </div>
                </div>
                <div class="Heziyun-right">
                    <div class="Heziyun-title">
                        {{ $t('company.feedback.typeTitle') }}<i>{{ $t('company.feedback.required')
                        }}</i>
                    </div>
                    <div class="Heziyun-tyle">
                        <a-tooltip :content="item.name" v-for="(item, index) in feedback_types">
                            <div class="Heziyun-item Heziyun-textOverflow" :style="getActiveStyle(item.id)"
                                @click="typeSelection = item.id" :key="item.id"
                                v-intersect="{ class: 'right-left', delay: index * 50 }">
                                {{ item.name }}
                            </div>
                        </a-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style>
@import "@/static/css/import";
@import "@/static/css/color.css";
@import "@/static/font/font.css";
</style>

<style lang="less" scoped>
@font-face {
    font-family: "italices";
    font-weight: 400;
    src: url("@/static/font/file/italics.woff2") format("woff2");
    font-display: swap;
}

// banner图
.Heziyun-banners {
    position: relative;

    .Heziyun-bannerImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .Heziyun-defaultWidth {
        position: relative;
        height: 100%;
        z-index: 1;

        .Heziyun-banner-title {
            color: #fff;
            align-items: center;

            p {
                text-align: center;
            }

            span {
                font-family: "italices";
            }
        }

    }
}


// 公司简介
.Heziyun-concise {
    background: url('@/static/img/company/summary.7fe07190.png') no-repeat;
    background-size: cover;
    height: 606px;
    position: relative;
    background-position: 50%;

    .Heziyun-defaultWidth {
        height: 100%;

        .Heziyun-content {
            display: flex;
            justify-content: space-between;
            height: 100%;

            .Heziyun-left {
                flex: 0.45;
                display: flex;
                flex-direction: column;
                gap: 1rem;

                .Heziyun-title {
                    color: rgba(9, 15, 25, 1);
                    font-size: 2rem;
                    font-family: "italices";

                    i {
                        color: #f39032;
                        font-style: normal;
                    }
                }

                p {
                    line-height: 1.8;
                    color: rgba(153, 153, 153, 1);
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 10;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                }

                .Heziyun-option {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    width: 100%;
                    gap: 1rem;
                    position: absolute;
                    bottom: -1.5rem;

                    .Heziyun-item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 0.3rem;

                        span {
                            font-size: 0.8rem;
                            color: rgba(7, 70, 255, 1);
                            display: flex;
                            gap: 0.2rem;
                            align-items: flex-end;

                            i {
                                font-size: 1.3rem;
                                font-style: normal;
                            }
                        }

                        p {
                            color: rgba(102, 102, 102, 1);
                        }

                        img {
                            width: 5rem;
                        }
                    }
                }
            }

            .Heziyun-right {
                flex: 0.5;
                position: absolute;
                left: 0;
                top: 0;
                z-index: -1;
                width: 50%;
                mask-image: linear-gradient(to right, black 0%, black 75%, transparent 100%);

                img {
                    width: 100%;
                    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
                }
            }
        }
    }
}

// 企业文化
.Heziyun-corporateCulture {
    background-color: rgb(243, 244, 247);

    .Heziyun-defaultWidth {
        .Heziyun-content {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 2rem;

            .Heziyun-item {
                background: linear-gradient(213.41deg, #f3f5f8 24.37%, #fff 80.13%), #fff;
                padding: 1.5rem 2rem;
                box-shadow: 27px 11px 24px rgba(210, 218, 227, .2), 0 24px 48px rgba(195, 203, 215, .14), -1px 1px 21px hsla(0, 0%, 100%, .9), inset -2px 2px 0 hsla(0, 0%, 100%, .94), inset 2px -2px 0 #fff;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                border-radius: 8px;

                &:hover {
                    transform: scale(1.03);
                    box-shadow: 27px 8px 24px rgba(210, 218, 227, .14), 0 24px 48px rgba(195, 203, 215, .3), 27px 11px 24px rgba(210, 218, 227, .24), inset -3px 3px 0 hsla(0, 0%, 100%, .94), inset 4px -2px 0 #fff;
                }

                img {
                    width: 2.5rem;
                    height: 2.5rem;
                }

                .Heziyun-text {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;

                    span {
                        font-size: 1.1rem;
                        font-weight: bold;
                    }

                    p {
                        color: #8c96a5;
                        font-size: 0.8rem;
                    }
                }
            }
        }
    }
}

// 资质认证
.Heziyun-qualifications {
    .Heziyun-defaultWidth {
        .Heziyun-content {
            height: 45rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .Heziyun-dashedLine {
                img {
                    width: 100%;
                    height: 1.5rem;
                    object-fit: cover;
                }
            }

            .Heziyun-location {
                position: absolute;
                top: 1rem;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 7rem 2rem;
                width: 100%;
                flex-wrap: wrap;

                .Heziyun-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 0.5rem;
                    width: 10.5rem;
                    transition: all 0.3s ease;
                    -webkit-transition: all 0.3s ease;
                    -moz-transition: all 0.3s ease;
                    -ms-transition: all 0.3s ease;
                    -o-transition: all 0.3s ease;

                    &:hover {
                        filter: drop-shadow(27px 11px 24px rgba(210, 218, 227, .24)) drop-shadow(0 24px 48px rgba(195, 203, 215, .3)) drop-shadow(-1px 1px 21px rgba(255, 255, 255, .9));
                        margin-top: -20px;
                        transition: all 0.3s ease;
                        -webkit-transition: all 0.3s ease;
                        -moz-transition: all 0.3s ease;
                        -ms-transition: all 0.3s ease;
                        -o-transition: all 0.3s ease;
                    }

                    &:nth-child(6)~* {
                        flex-direction: column-reverse;
                    }

                    // 最后一个
                    &:last-child {
                        margin-right: 13rem;
                    }

                    img {
                        display: -ms-flexbox;
                        display: flex;
                        -ms-flex-align: center;
                        align-items: center;
                        width: 100%;
                        height: 260px;
                        padding: 11px;
                        background: radial-gradient(29.31% 101.63% at 72.5% -46.08%, rgba(253, 179, 255, .16) 12.47%, hsla(0, 0%, 100%, 0) 100%), radial-gradient(31.01% 107.52% at 88.92% -48.37%, rgba(179, 237, 255, .32) 12.47%, hsla(0, 0%, 100%, 0) 100%), linear-gradient(213.41deg, #f3f5f8 24.37%, #fff 80.13%), #fff;
                        box-shadow: 16px 7px 26px rgba(210, 218, 227, .37), 0 16px 30px rgba(195, 203, 215, .22), inset -2px 2px 0 hsla(0, 0%, 100%, .94), inset 2px -1px 0 #fff;
                        border-radius: 8px;
                        cursor: default;
                    }

                    .Heziyun-flexmin {
                        text-align: center;

                        .Heziyun-time {
                            font-weight: 600;
                            font-size: 1rem;
                            line-height: 1.7;
                            color: #161616;
                        }

                        p {
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-weight: 400;
                            font-size: 0.75rem;
                            line-height: 1.7;
                            text-align: center;
                            color: #8c96a5;
                        }
                    }


                }
            }
        }
    }
}

// 荣誉之路
.Heziyun-pathwayToGlory {
    background: url('@/static/img/company/pic_about_honor_bg@2x.png') no-repeat center;
    background-size: cover;

    .Heziyun-defaultWidth {
        .Heziyun-content {
            display: flex;
            flex-direction: column;
            gap: 2rem;

            .Heziyun-item {
                display: flex;
                gap: 1rem;

                // 偶数
                &:nth-child(even) {
                    .Heziyun-dividingLine {
                        display: flex;
                        flex-direction: column;

                        .Heziyun-circular {
                            background-color: #1a66ff;
                        }
                    }
                }

                .Heziyun-year {
                    font-size: 2.3rem;
                    font-family: "din";
                    color: rgb(26, 102, 255);
                }

                .Heziyun-dividingLine {
                    display: flex;
                    flex-direction: column;

                    .Heziyun-circular {
                        width: 12px;
                        height: 12px;
                        border: 2px solid #1a66ff;
                        border-radius: 50%;
                        position: relative;
                        animation: pulses 2s infinite ease-in-out, rotate 4s infinite linear;
                        -webkit-animation: pulses 2s infinite ease-in-out, rotate 4s infinite linear;

                        &::before {
                            content: '';
                            position: absolute;
                            top: -4px;
                            left: -4px;
                            right: -4px;
                            bottom: -4px;
                            border: 2px solid rgba(26, 102, 255, 0.3);
                            border-radius: 50%;
                            animation: pulses 2s infinite 0.5s ease-in-out;
                            -webkit-animation: pulses 2s infinite 0.5s ease-in-out;
                        }
                    }

                    .Heziyun-line {
                        width: 2px;
                        height: calc(100% - 12px);
                        margin-left: 5px;
                        background: linear-gradient(1turn, hsla(0, 0%, 100%, 0), #1a66ff);
                        position: relative;
                        overflow: hidden;

                        &::after {
                            content: '';
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            background: linear-gradient(to bottom,
                                    transparent 0%,
                                    rgba(26, 102, 255, 0.8) 50%,
                                    transparent 100%);
                            animation: shine 3s infinite linear;
                        }
                    }
                }

                @keyframes pulses {
                    0% {
                        transform: scale(1);
                        opacity: 1;
                    }

                    50% {
                        transform: scale(1.2);
                        opacity: 0.7;
                    }

                    100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                }

                @keyframes rotate {
                    0% {
                        transform: rotate(0deg);
                    }

                    100% {
                        transform: rotate(360deg);
                    }
                }

                @keyframes shine {
                    0% {
                        transform: translateY(-100%);
                        opacity: 0;
                    }

                    20% {
                        opacity: 1;
                    }

                    100% {
                        transform: translateY(100%);
                        opacity: 0;
                    }
                }

                .Heziyun-son {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                    width: 100%;

                    .Heziyun-itemSon {
                        border: 1.5px solid #fff;
                        border-radius: 4px;
                        box-shadow: 0 2px 4px 0 rgba(175, 190, 198, .15);
                        padding: 0.7rem 1rem;
                        display: flex;
                        flex-direction: column;
                        gap: 0.5rem;
                        background-color: #ffffff4a;

                        span {
                            font-size: 0.9rem;
                        }

                        p {
                            color: #858c99;
                            font-size: 0.7rem;
                        }
                    }
                }
            }


        }
    }
}

// 咨询反馈
.Heziyun-consultationFeedback {
    background: url('@/static/img/company/back3.jpg') no-repeat center;
    background-size: cover;

    .Heziyun-defaultWidth {
        .Heziyun-content {
            display: flex;
            justify-content: center;

            .Heziyun-left {
                width: 40%;
                display: flex;
                flex-direction: column;
                gap: 1rem;

                .Heziyun-title {
                    color: rgb(22, 32, 58);
                    font-size: 1rem;
                }

                input {
                    height: 2.2rem;
                    padding: 0 1rem;
                    width: 25rem;
                    border: 1px solid rgb(242, 245, 246);
                    background: radial-gradient(29.31% 101.63% at 72.5% -46.08%, rgba(253, 179, 255, 0.16) 12.47%, hsla(0, 0%, 100%, 0) 100%), radial-gradient(31.01% 107.52% at 88.92% -48.37%, rgba(179, 237, 255, 0.32) 12.47%, hsla(0, 0%, 100%, 0) 100%), linear-gradient(213.41deg, #f3f5f8 24.37%, #fff 80.13%), #fff;
                    box-shadow: 16px 7px 26px rgba(210, 218, 227, 0.37), 0 16px 30px rgba(195, 203, 215, 0.22), inset -2px 2px 0 hsla(0, 0%, 100%, 0.94), inset 2px -1px 0 #fff;

                    &::placeholder {
                        font-size: 0.788rem;
                    }

                    &:focus {
                        border-color: #1a66ff;

                        &::placeholder {
                            color: #1a66ff;
                        }
                    }
                }

                .error {
                    border: 1px solid red !important;
                    color: red;
                }

                .error::placeholder {
                    color: red !important;
                }


                textarea {
                    background: radial-gradient(29.31% 101.63% at 72.5% -46.08%, rgba(253, 179, 255, 0.16) 12.47%, hsla(0, 0%, 100%, 0) 100%), radial-gradient(31.01% 107.52% at 88.92% -48.37%, rgba(179, 237, 255, 0.32) 12.47%, hsla(0, 0%, 100%, 0) 100%), linear-gradient(213.41deg, #f3f5f8 24.37%, #fff 80.13%), #fff;
                    box-shadow: 16px 7px 26px rgba(210, 218, 227, 0.37), 0 16px 30px rgba(195, 203, 215, 0.22), inset -2px 2px 0 hsla(0, 0%, 100%, 0.94), inset 2px -1px 0 #fff;
                    padding: 1rem;
                    width: 25rem;
                    border: 1px solid rgb(242, 245, 246);
                    max-height: 12rem;
                    min-height: 12rem;
                    resize: none;
                    line-height: 1.7;

                    &::placeholder {
                        font-size: 0.788rem;
                    }

                    &:focus {
                        border-color: #1a66ff;

                        &::placeholder {
                            color: #1a66ff;
                        }
                    }

                    /* 滚动条样式 */
                    &::-webkit-scrollbar {
                        width: 4px;
                        height: 4px;
                    }

                    &::-webkit-scrollbar-thumb {
                        background-color: rgba(0, 0, 0, 0.6);
                        border-radius: 2px;
                    }

                    &::-webkit-scrollbar-track {
                        background-color: transparent;
                    }
                }

                .error {
                    border: 1px solid red !important;
                    color: red;
                }

                .error::placeholder {
                    color: red !important;
                }

                .Heziyun-submit {
                    width: fit-content;
                }

            }

            .Heziyun-right {
                width: 40%;
                display: flex;
                flex-direction: column;
                gap: 1rem;

                .Heziyun-title {
                    color: rgb(22, 32, 58);
                    font-size: 1rem;

                    i {
                        font-size: 0.8rem;
                        color: #1a66ff;
                        font-style: normal;
                    }
                }

                .Heziyun-tyle {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 0.5rem;

                    .Heziyun-item {
                        background-color: rgb(245, 247, 249);
                        color: rgb(40, 48, 70);
                        padding: 0.4rem 1rem;
                        font-size: 0.8rem;
                        cursor: pointer;
                        width: calc(100% / 4 - 1.5rem);
                        text-align: center;
                    }
                }
            }
        }
    }
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {

    /* Banner Section */
    .Heziyun-banners {
        .Heziyun-defaultWidth {
            .Heziyun-banner-title {
                p {
                    font-size: 4vw;
                }
            }
        }
    }

    /* Company Introduction */
    .Heziyun-concise {
        background: transparent;
        padding: 0;
        height: auto;
        padding-bottom: 5vw;

        .Heziyun-defaultWidth {
            padding: 0;

            .Heziyun-content {
                flex-direction: column-reverse;

                .Heziyun-left {
                    flex: 1;
                    padding: 4vw;

                    .Heziyun-title {
                        font-size: 8vw;
                        text-align: center;
                    }

                    p {
                        font-size: 3.5vw;
                        text-align: center;
                    }

                    .Heziyun-option {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 3vw;
                        margin-top: 4vw;
                        position: initial;

                        .Heziyun-item {
                            gap: 2vw;

                            span {
                                font-size: 3vw;

                                i {
                                    font-size: 4vw;
                                }
                            }

                            p {
                                font-size: 3.5vw;
                            }

                            img {
                                width: 15vw;
                            }
                        }
                    }
                }

                .Heziyun-right {
                    flex: 1;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: -1;
                    width: 100%;
                    height: 100%;
                    mask-image: linear-gradient(to top, black 0%, black 75%, transparent 100%);

                    img {
                        object-fit: cover;
                        height: 100%;
                    }
                }
            }
        }
    }

    /* Corporate Culture */
    .Heziyun-corporateCulture {
        .Heziyun-defaultWidth {
            .Heziyun-content {
                grid-template-columns: 1fr;
                gap: 3vw;
                padding: 4vw;

                .Heziyun-item {
                    padding: 3vw 4vw;
                    gap: 2vw;

                    img {
                        width: 8vw;
                        height: 8vw;
                    }

                    .Heziyun-text {
                        span {
                            font-size: 4vw;
                        }

                        p {
                            font-size: 3vw;
                        }
                    }
                }
            }
        }
    }

    /* Qualifications */
    .Heziyun-qualifications {
        .Heziyun-defaultWidth {
            .Heziyun-content {
                height: auto;
                padding: 6vw 0;

                .Heziyun-dashedLine {
                    display: none;
                    /* 移动端隐藏虚线 */
                }

                .Heziyun-location {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 4vw;
                    position: initial;
                    transform: translateX(0%);

                    .Heziyun-item {
                        width: auto;
                        flex-direction: column;
                        margin: 0 !important;

                        &:nth-child(6)~* {
                            flex-direction: column;
                            /* 统一方向 */
                        }

                        img {
                            height: 50vw;
                            width: 100%;
                            object-fit: contain;
                            padding: 2vw;
                        }

                        .Heziyun-flexmin {
                            width: 100%;

                            .Heziyun-time {
                                font-size: 4.5vw;
                                margin-bottom: 1vw;
                            }

                            p {
                                font-size: 3.5vw;
                                -webkit-line-clamp: 3;
                                /* 增加显示行数 */
                            }
                        }
                    }
                }
            }
        }
    }

    /* Pathway to Glory */
    .Heziyun-pathwayToGlory {
        .Heziyun-defaultWidth {
            .Heziyun-content {
                gap: 6vw;
                padding: 4vw;

                .Heziyun-item {
                    gap: 3vw;

                    .Heziyun-year {
                        font-size: 6vw;
                    }

                    .Heziyun-son {
                        .Heziyun-itemSon {
                            padding: 3vw;

                            span {
                                font-size: 3.5vw;
                            }

                            p {
                                font-size: 2.5vw;
                            }
                        }
                    }
                }
            }
        }
    }

    /* Consultation Feedback */
    .Heziyun-consultationFeedback {
        .Heziyun-defaultWidth {
            .Heziyun-content {
                flex-direction: column-reverse;
                /* 表单在下更符合移动端习惯 */
                padding: 6vw 4vw;
                gap: 8vw;

                .Heziyun-left {
                    width: 100%;

                    .Heziyun-title {
                        font-size: 5vw;
                        margin-bottom: 3vw;
                    }

                    input,
                    textarea {
                        width: 100%;
                        font-size: 4vw;
                        padding: 3vw 4vw;
                        margin-bottom: 3vw;
                        height: 10vw;

                        &::placeholder {
                            font-size: 3.5vw;
                        }
                    }

                    textarea {
                        min-height: 30vw;
                        max-height: 50vw;
                    }

                    .Heziyun-submit {
                        margin-top: 2vw;
                    }
                }

                .Heziyun-right {
                    width: 100%;


                    .Heziyun-title {
                        font-size: 5vw;
                        margin-bottom: 3vw;

                        i {
                            font-size: 4vw;
                        }
                    }

                    .Heziyun-tyle {
                        gap: 2vw;

                        .Heziyun-item {
                            width: 100%;
                            /* 全宽按钮更易点击 */
                            padding: 3vw;
                            font-size: 3.8vw;
                            border-radius: 1vw;
                            margin-bottom: 2vw;
                        }
                    }
                }
            }
        }
    }
}
</style>